import { render, staticRenderFns } from "./purchase-order-base.vue?vue&type=template&id=64c38a39&"
import script from "./purchase-order-base.vue?vue&type=script&lang=ts&"
export * from "./purchase-order-base.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports